<template>
<span class="list-box">
    <div class="content">
        <span :class="boxName=='projectList'?'projectListBoxTitle':'electricityListBoxTitle'">
            <slot>{{title}}</slot>
        </span>
    </div>
</span>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default () {
                return []
            }
        },
        boxName: ""
    },
    data() {
        return {
            title: ''
        }
    },
    methods: {},
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
.list-box {
    background: url("/static/images/svolt/projectList.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    top: 0;
    left: 0;
    width: 360px;
    height: 53.5vh;
    display: inline-block;

    .content {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 10;
        color: #0B0B3D;

        .projectListBoxTitle {
            font-size: 20px;
            font-family: pmzd;
            display: inline-block;
            line-height: 20px;
            margin-left: 30px;
        }

        .electricityListBoxTitle {
            font-size: 20px;
            font-family: pmzd;
            display: inline-block;
            line-height: 25px;
            margin-left: 30px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/list-box.vue